import React, { FC } from 'react';
import { ReactComponent as Percentage } from '../../../assets/Dashboard/Percentage.svg';

export const PercentageIcon: FC = () => <Percentage />;
